import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from 'ui';
import * as types from '../types';

const ShowMore = ({ currentTotal, filter, onClick }) => {
  if (currentTotal === 0) return null;
  const hasMore = filter.searchCount > currentTotal;
  const count = Math.min(filter.perPage, filter.searchCount - currentTotal);
  return (
    hasMore && (
      <button
        type="button"
        className="u-linkBtn w-fill p-16 bt-gray-lighter"
        onClick={onClick}
      >
        <Icon name="add" className="mr-4" />
        {t('in_person_training.event_overview.attendance.show_more_button', {
          count,
        })}
      </button>
    )
  );
};

ShowMore.propTypes = {
  currentTotal: PropTypes.number,
  filter: types.Filter,
  onClick: PropTypes.func,
};

export default ShowMore;
